import React from 'react';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';

const PLACEHOLDER_TEXT = 'Контент для бегущей строки не найден';
/** Синхронно с `$ticker-duplicates` в index.module.scss (keyframes run → -100%/N). */
const TICKER_CONTENT_COPIES = 6;

const RuningLine = () => {
  const runningLineContent = useSelector((state) => state.others_data?.running_line_content || []);

  const tickerItems = React.useMemo(() => {
    const groups = Array.isArray(runningLineContent) ? runningLineContent : [];
    const normalizeText = (rawValue) => {
      const text = String(rawValue ?? '').trim().replace(/^"+|"+$/g, '');
      if (!text || text.toLowerCase() === 'none') return '';
      return text;
    };

    const normalizeHref = (rawHref) => {
      const href = normalizeText(rawHref);
      if (!href) return '';
      if (/^https?:\/\//i.test(href)) return href;
      return `https://${href}`;
    };

    const collectLeafRows = (value) => {
      if (!Array.isArray(value) || value.length === 0) return [];
      if (!Array.isArray(value[0])) return [value];
      return value.flatMap((entry) => collectLeafRows(entry));
    };

    const getPairPayload = (candidatePair) => {
      const text = normalizeText(candidatePair[0]);
      if (!text) return null;

      const href = normalizeHref(candidatePair[1]);
      const extraFields = candidatePair
        .slice(2)
        .map((value) => normalizeText(value))
        .filter(Boolean);

      const source = extraFields[0] || '';
      return { text, href, source, extraFields };
    };

    const normalized = groups
      .flatMap((group) => collectLeafRows(group))
      .map((candidatePair) => getPairPayload(candidatePair))
      .filter(Boolean);

    if (normalized.length === 0) {
      return [{ text: PLACEHOLDER_TEXT, href: '' }];
    }

    return normalized;
  }, [runningLineContent]);

  const tickerTrackItems = React.useMemo(
    () => Array.from({ length: TICKER_CONTENT_COPIES }, () => tickerItems).flat(),
    [tickerItems],
  );

  return (
    <section className={styles.tickerBlock} aria-label='Бегущая строка'>
      <div className={styles.ticker}>
        <div className={styles.tickerTrack}>
          {tickerTrackItems.map((item, index) =>
            item.href ? (
              <a
                key={`t-${index}-${item.text}`}
                className={styles.tickerItemLink}
                href={item.href}
                target='_blank'
                rel='noreferrer'>
                {item.text}
              </a>
            ) : (
              <span className={styles.tickerItem} key={`t-${index}-${item.text}`}>
                {item.text}
              </span>
            ),
          )}
        </div>
      </div>
    </section>
  );
};

export default RuningLine;
